import {
  CompaniesItems,
  Company,
  CompanyBody,
  GetPlanAction,
} from "@vviinn/user-managment-client-ts";
import { getIdFromUrl } from "../helpers";

export type CompanyAllPlansRequest = {
  companyId: Company["id"];
  action: GetPlanAction;
};

export type MandatoryCompanyId = Exclude<CompanyBody["id"], undefined>;

export type CompanyRequest = {
  companyId: MandatoryCompanyId;
};

export const getCompanyIdFromUrl = (url: string) =>
  getIdFromUrl(url)("company", 1, 2) as MandatoryCompanyId;

export type CompanyFilters =
  | "Any Contract"
  | "Active Contract"
  | "No Active Contract"
  | "Any Plan"
  | "Valid Plan"
  | "No Plan"
  | "Expired Plan";

export const companyName = (
  userCompanyId: string,
  companies: CompaniesItems[],
) => {
  return (
    companies.find((company) => company.id === userCompanyId)?.name ??
    "Unknown company"
  );
};
